import { render, staticRenderFns } from "./ParticipanDetail.vue?vue&type=template&id=858fce3c&scoped=true&"
import script from "./ParticipanDetail.vue?vue&type=script&lang=js&"
export * from "./ParticipanDetail.vue?vue&type=script&lang=js&"
import style0 from "./ParticipanDetail.vue?vue&type=style&index=0&id=858fce3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "858fce3c",
  null
  
)

export default component.exports